export default function browserName() {
    var nAgt = navigator.userAgent;
    var browserName = navigator.appName;
    var fullVersion = "" + parseFloat(navigator.appVersion);
    var majorVersion = parseInt(navigator.appVersion, 10);
    var verOffset;
    var version;
    var isoldbrowser;
    // In Chrome, the true version is after "Chrome"
    if ((verOffset = nAgt.indexOf("Chrome")) !== -1) {
        browserName = "Chrome";
        fullVersion = nAgt.substring(verOffset + 7);
        version = getversionnumber(fullVersion);
        majorVersion = version.majorVersion;
        if (version.majorVersion <= 30)
            isoldbrowser = true;
    }
    else if (nAgt.indexOf("Trident/") !== -1 && nAgt.indexOf("rv:") !== -1) {
        browserName = "Microsoft Internet Explorer";
        var rv = nAgt.indexOf("rv:");
        fullVersion = nAgt.substring(rv + 3);
        version = getversionnumber(fullVersion);
        majorVersion = version.majorVersion;
        if (version.majorVersion < 10)
            isoldbrowser = true;
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf("MSIE")) !== -1) {
        browserName = "Microsoft Internet Explorer";
        fullVersion = nAgt.substring(verOffset + 5);
        version = getversionnumber(fullVersion);
        majorVersion = version.majorVersion;
        if (version.majorVersion < 3)
            isoldbrowser = true;
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf("Safari")) !== -1) {
        browserName = "Safari";
        fullVersion = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf("Version")) !== -1)
            fullVersion = nAgt.substring(verOffset + 8);
        version = getversionnumber(fullVersion);
        majorVersion = version.majorVersion;
        if (version.majorVersion < 5)
            isoldbrowser = true;
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf("Firefox")) !== -1) {
        browserName = "Firefox";
        fullVersion = nAgt.substring(verOffset + 8);
        version = getversionnumber(fullVersion);
        majorVersion = version.majorVersion;
        if (version.majorVersion <= 30)
            isoldbrowser = true;
    }
    // In Opera, the true version is after "Opera" or after "Version"
    else if ((verOffset = nAgt.indexOf("Opera")) !== -1) {
        browserName = "Opera";
        fullVersion = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf("Version")) !== -1)
            fullVersion = nAgt.substring(verOffset + 8);
        version = getversionnumber(fullVersion);
        majorVersion = version.majorVersion;
        if (version.majorVersion <= 30)
            isoldbrowser = true;
    }
    return { browserName: browserName, version: version, isoldbrowser: isoldbrowser };
}
function getversionnumber(fullVersion) {
    var ix;
    if ((ix = fullVersion.indexOf(";")) !== -1)
        fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(" ")) !== -1)
        fullVersion = fullVersion.substring(0, ix);
    var majorVersion = parseInt("" + fullVersion, 10);
    if (isNaN(majorVersion)) {
        fullVersion = "" + parseFloat(navigator.appVersion);
        majorVersion = parseInt(navigator.appVersion, 10);
    }
    return {
        fullVersion: fullVersion,
        majorVersion: majorVersion
    };
}
